import { CTAPIConfiguration, ApiMethodConfiguration } from './configuration';
import { RequestUtils } from '../../utils/request.utils';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export class RequestHelper {

    private globalConfig: CTAPIConfiguration;

    constructor(configuration: CTAPIConfiguration) {
        this.globalConfig = configuration;
    }

    /**
     * Makes a request.
     */
    request(dto: any, configuration: ApiMethodConfiguration, httpClient: HttpClient): Observable<any> {
        // strip the trailing slash from the base URL when present to avoid double slashes.
        const baseUrl = this.globalConfig.baseUrl.replace(/\/$/, '');
        const options = {
            url: baseUrl + configuration.path,
            method: configuration.method,
            headers: configuration.headers,
            body: dto,
            json: true
        };
        return RequestUtils.promisifyRequest(options, httpClient);
    }

}
